export const color = {
  bg: {
    primary: '#ffffff',
    secondary: '#2C2c2c',
    tertiary: '#152E63',
    muted: '#f2f2f2',
    // Fundos de aviso (30/out/2026): o Figma não tem variável para eles; são
    // as cores de status da paleta sobre o branco (laranja 10%, vermelho 6%,
    // verde 10%). Substituíram ~30 tons de bege/rosa/verde soltos nas telas.
    warning: '#fef4e9',
    danger: '#fef1f1',
    success: '#ebf7ed',
  },
  text: {
    primary: '#333333',
    secondary: '#ff7f3f',
    tertiary: '#152e63',
    quaternary: '#999999',
    inverse: '#ffffff',
    danger: '#f42121',
    success: '#37b34a',
    disabled: '#999999',
  },
  ui: {
    primary: '#f79422',
    secondary: '#f9d815',
    tertiary: '#152e63',
    danger: '#f42121',
    success: '#98c52f',
    muted: '#e6e6e6',
    orange: '#f79422',
    yellow: '#f9d815',
    darkBlue: '#152e63',
    orangeAlt: '#ff7f3f',
    red: '#f42121',
    green: '#98c52f',
    greenAlt: '#37B34A',
    darkGreen: '#709123',
    redAlt: '#c21b1b',
    yellowAlt: '#c7ab10',
    blue: '#1345b0',
    brown: '#785935',
    shade0: '#ffffff',
    shade1: '#f2f2f2',
    shade2: '#e6e6e6',
    shade3: '#999999',
    shade4: '#333333',
  },
};
